import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";
const Data = () => {
  // You can fetch data from an API or define it here statically

  const { multiLanguageData } = useSelector((state) => state?.main);

  const {
    TEXT_HEADING_TICKETS = English?.TakeATour?.TEXT_HEADING_TICKETS,
    TEXT_SUBHEADING_TICKETS = English?.TakeATour?.TEXT_SUBHEADING_TICKETS,
    TEXT_HEADING_SITES = English?.TakeATour?.TEXT_HEADING_SITES,
    TEXT_SUBHEADING_SITES = English?.TakeATour?.TEXT_SUBHEADING_SITES,
    TEXT_HEADING_CHAT = English?.TakeATour?.TEXT_HEADING_CHAT,
    TEXT_SUBHEADING_CHAT = English?.TakeATour?.TEXT_SUBHEADING_CHAT,
    TEXT_HEADING_TIMESHEETS = English?.TakeATour?.TEXT_HEADING_TIMESHEETS,
    TEXT_SUBHEADING_TIMESHEETS = English?.TakeATour?.TEXT_SUBHEADING_TIMESHEETS,
    TEXT_HEADING_EXPENSES = English?.TakeATour?.TEXT_HEADING_EXPENSES,
    TEXT_SUBHEADING_EXPENSES = English?.TakeATour?.TEXT_SUBHEADING_EXPENSES,
    TEXT_HEADING_CARPOOL = English?.TakeATour?.TEXT_HEADING_CARPOOL,
    TEXT_SUBHEADING_CARPOOL = English?.TakeATour?.TEXT_SUBHEADING_CARPOOL,
  } = multiLanguageData?.TakeATour || {};


  const ticketData = [
    {
      heading: TEXT_HEADING_TICKETS,
      text: TEXT_SUBHEADING_TICKETS,
    },
  ];
  const chatData = [
    {
      heading: TEXT_HEADING_CHAT,
      text: TEXT_SUBHEADING_CHAT,
    }
  ];

  const sitesData = [
    {
      heading: TEXT_HEADING_SITES,
      text: TEXT_SUBHEADING_SITES,
    },
  ];
  const timesheetData = [
    {
      heading: TEXT_HEADING_TIMESHEETS,
      text: TEXT_SUBHEADING_TIMESHEETS,
    },
  ];
  const expensesData = [
    {
      heading: TEXT_HEADING_EXPENSES,
      text: TEXT_SUBHEADING_EXPENSES,
    },
  ];
  const carPoolData = [
    {
      heading: TEXT_HEADING_CARPOOL,
      text: TEXT_SUBHEADING_CARPOOL,
    },

  ];
  const jobPostingData = [
    {
      heading: "See Who's Hiring",
      text: "Explore thousands of up-to-date jobs for all trades in BuildID, and easily apply with your in-app resume.",
    },

  ];

  return { ticketData, chatData, sitesData, timesheetData, expensesData, carPoolData, jobPostingData };
};

export default Data;
